import * as React from "react"
import { Navigate } from "react-router-dom"

import { BATCH_ADMIN_ROUTES, USER_ROLE } from "@constants"
import AppLayout from "Layout"
import BatchesPage from "./Batches"


export const BatchAdminRoutes = {
    path: BATCH_ADMIN_ROUTES.PATH,
    title: "Mapping Batches",
    icon: 'layer-group',
    iconWeight: 'light',
    element: <AppLayout />,
    description: '',
    access: USER_ROLE.ADMIN,
    children: [{
        element: <Navigate to={BATCH_ADMIN_ROUTES.LIST_PATH} replace />, index: true
    }, {
        path: BATCH_ADMIN_ROUTES.LIST_PATH,
        element: <BatchesPage />
    }]
}
